<scaffold-dialog [title]="data.title" [fit]="true">
  <div scaffoldDialogBody>
    <p>{{data.message}}</p>
  </div>
  <div scaffoldDialogButtons>
      <button nbButton status="secondary" (click)="onNoClick()">{{data.declineMessage || 'no'| translation}}</button>
      <button nbButton status="primary" cdkFocusInitial (click)="onYesClick()">{{data.confirmMessage ||'yes'| translation}}</button>
  </div>
</scaffold-dialog>
